// Imported FIRST by main.tsx (ADR 0016): before any other module runs, the page's CSP nonce is given
// to the code that inserts <style> elements at run time. `style-src` admits only 'self' and the nonce;
// libraries that create style elements from script (sonner at import, react-remove-scroll behind
// Radix dialogs) would otherwise be refused. Elements made by `document.createElement` (only the app's
// own scripts, which the script policy already trusts) get the nonce; <style> in injected markup
// (innerHTML, the parser) never does, so it stays blocked.
// The one file of a module the host reads past its front door: it imports nothing, so nothing runs before the stamp.
import { cspNonce, shareNonce } from '../modules/platform/nonce.ts';

export function stampStyleNonces(doc: Document = document) {
  const nonce = cspNonce(doc);
  if (!nonce) return;
  const proto = Object.getPrototypeOf(doc) as Document;
  const create = proto.createElement;
  if ((create as { cortexNonce?: boolean }).cortexNonce) return;
  const stamped = function (this: Document, tag: string, options?: ElementCreationOptions) {
    const el = create.call(this, tag, options);
    if (el instanceof HTMLStyleElement && !el.nonce) el.nonce = nonce;
    return el;
  } as typeof create;
  (stamped as { cortexNonce?: boolean }).cortexNonce = true;
  proto.createElement = stamped;
}

shareNonce();
stampStyleNonces();
